<template>
  <tr>
    <td>
      <a-checkbox @click="SWITCH_SAIB(idx)" :checked="$store.state.saib.selected.includes(idx)" />
    </td>
    <td v-if="isPC">
      <p v-if="status === 0">
        <a-badge status="default" />
        <b>접수</b>
      </p>
      <p v-if="status === 1">
        <a-badge status="processing" />
        <b>처리 중</b>
      </p>
      <p v-if="status === 2">
        <a-badge status="success" />
        <b>성공</b>
      </p>
      <p v-if="status === 3">
        <a-badge status="error" />
        <b>실패</b>
      </p>
      <p v-if="status === 4">
        <a-badge status="warning" />
        <b>대기</b>
      </p>

      <a-button
        v-if="status >= 1"
        style="margin-top: 5px;"
        type="dashed"
        shape="round"
        icon="message"
        size="small"
        @click="viewContentsFromSaib(idx)"
      >메세지</a-button>
    </td>
    <td v-if="isPC">{{ wholesale.name }}</td>
    <td v-if="isPC">
      {{ wholesale.location.building }}
      <b>({{ wholesale.location.mall }})</b>
      <br />
      <a-badge
        :count="
          `${wholesale.location.floor}층 ${wholesale.location.row}열 ${wholesale.location.place}호`
        "
        :numberStyle="{ backgroundColor: '#52c41a' }"
      />
    </td>
    <td v-if="isPC">{{ price.toLocaleString() }}원</td>
    <SaibItemDetail v-if="isPC" :items="details" />
    <td v-if="isPC">
      {{ uploadAt.format('LL') }}
      <br />
      {{ uploadAt.format('LT') }}
      <b>({{ uploadAt.fromNow() }})</b>
    </td>
    <td v-else style="text-align: left;">
      <dl>
        <dt>상태:</dt>
        <dd>
          <p v-if="status === 0">
            <a-badge status="default" />
            <b>접수</b>
          </p>
          <p v-if="status === 1">
            <a-badge status="processing" />
            <b>처리 중</b>
          </p>
          <p v-if="status === 2">
            <a-badge status="success" />
            <b>성공</b>
          </p>
          <p v-if="status === 3">
            <a-badge status="error" />
            <b>실패</b>
          </p>
          <p v-if="status === 4 && type === 0">
            <a-badge status="warning" />
            <b>대기</b>
          </p>
          <p v-if="status === 4 && type === 1">
            <a-badge status="warning" />
            <b>맡김</b>
          </p>

          <a-button
            v-if="status >= 1"
            style="margin-top: 5px;"
            type="dashed"
            shape="round"
            icon="message"
            size="small"
            @click="viewContentsFromSaib(idx)"
          >메세지</a-button>
        </dd>
        <dt>매장 이름:</dt>
        <dd>{{ wholesale.name }}</dd>
        <dt>위치:</dt>
        <dd>{{ wholesale.location.building }} ({{ wholesale.location.mall }})</dd>
        <dt>층/열/호:</dt>
        <dd>
          {{
          `${wholesale.location.floor}층 ${wholesale.location.row}열 ${wholesale.location.place}호`
          }}
        </dd>
        <dt>예상 금액:</dt>
        <dd>
          {{ price.toLocaleString() }}
          <span style="margin-left: 6px">원</span>
        </dd>
        <dt>주문 내역:</dt>
        <SaibItemDetail :items="details" />
      </dl>
    </td>
  </tr>
</template>
<script>
import SaibItemDetail from "./SaibItemDetail";
import { mapMutations, mapActions } from "vuex";
import { TYPES } from "../../stores/saib";

export default {
  name: "SaibItem",
  components: { SaibItemDetail },
  methods: {
    ...mapMutations([TYPES.SWITCH_SAIB]),
    ...mapActions(["viewContentsFromSaib"])
  },
  props: ["idx", "status", "wholesale", "details", "price", "uploadAt"]
};
</script>
